/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portals_Family_IdnesInputs */

const cs_portals_family_idnes = /** @type {(inputs: Portals_Family_IdnesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FTP + HTTP`)
};

const en_portals_family_idnes = /** @type {(inputs: Portals_Family_IdnesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FTP + HTTP`)
};

/**
* | output |
* | --- |
* | "FTP + HTTP" |
*
* @param {Portals_Family_IdnesInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portals_family_idnes = /** @type {((inputs?: Portals_Family_IdnesInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portals_Family_IdnesInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portals_family_idnes(inputs)
	return cs_portals_family_idnes(inputs)
});